import React, { useState } from "react";
import { Button, Row, Col, Form } from "react-bootstrap";
import { Draggable } from "react-beautiful-dnd";
import jsDig from "utils/jsDig.js";
const handleSrc = require("images/icons/ui-handle.png");
const boxHandle = (
  <>
    <span className="box-handle-helper"></span>
    <img src={`/datapulse${handleSrc}`} className="handle-icon" />
  </>
);

export default function LandingPage(props) {
  const lpGroup = props.lpGroups.find((el) => el.id == props.lpGroupId);
  const lpGroupId = props.lpGroupId.toString();

  const conditionHtml = (type, url, index, conditionsLength) => {
    return (
      <>
      <div class="seo-config-landingpage-tracking-condition-box">
       <div className="px-3 pt-0 pb-3 mb-2" style={{ backgroundColor: "#EEEEEE" }}>
       <div class = "seo-config-landingpage-tracking-equals-url-box">
          <Row className="pt-3" style={{ position: "relative" }}>
            <i
              style={conditionsLength == 1 ? { display: "none", right: "-1.5vw" } : {}}
              className="pt-3 pl-2 fas fa-minus-circle ml-auto"
              onClick={(e) => {
                let newLpGroups = props.lpGroups;
                let targetIndex = newLpGroups.indexOf(newLpGroups.find((group) => group.id == lpGroupId));
                newLpGroups[targetIndex]["conditions"].splice(index, 1);
                props.setLpGroups([...newLpGroups]);
              }}></i>
            
            <Col>
            <select
                style={{ width: "140px", paddingLeft: "5px" }}
                value={type ? type : "equals"}
                onChange={(e) => {
                  let newLpGroups = props.lpGroups;
                  let targetIndex = newLpGroups.indexOf(newLpGroups.find((group) => group.id == lpGroupId));
                  newLpGroups[targetIndex]["conditions"][index].type = e.target.value;
                  props.setLpGroups([...newLpGroups]);
                }}>
                <option value="equals">Equals</option>
                <option value="contains">Contains</option>
              </select>
              </Col>
          </Row>
         </div>
          <Row className="pt-2 seo-config-landingpage-tracking-url-bar flex-column">
            <Col style={{ maxWidth: "60px" }}>URL:</Col>
            <Col>
             <input
                style={{ paddingLeft: "5px" }}
                value={url ? url : ""}
                onChange={(e) => {
                  let newLpGroups = props.lpGroups;
                  let targetIndex = newLpGroups.indexOf(newLpGroups.find((group) => group.id == lpGroupId));
                  newLpGroups[targetIndex]["conditions"][index].url = e.target.value;
                  props.setLpGroups([...newLpGroups]);
                }}
              />
              
             </Col>
          </Row>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <Draggable draggableId={lpGroupId} index={props.index}>
        {(provided) => (
          <div {...provided.draggableProps} ref={provided.innerRef} className="landing-page-group-section d-flex dark-grey">
            <div {...provided.dragHandleProps} className="landing-page-group-section-handle px-2" style={{ backgroundColor: "#CACACA", padding: "15px" }}>
              {boxHandle}
            </div>
            <div className="landing-page" style={{ padding: "25px 15px", position: "relative", width: "calc(100% - 35px)" }}>
              <i
                className="pt-3 pl-2  fas fa-minus-circle ml-auto"
                onClick={(e) => {
                  let newLpGroups = props.lpGroups;
                  let targetIndex = newLpGroups.indexOf(newLpGroups.find((group) => group.id == lpGroupId));
                  let newSectionOrder = props.sectionOrder;
                  newSectionOrder.splice(props.index, 1);
                  props.setSectionOrder(newSectionOrder);
                  newLpGroups.splice(targetIndex, 1);
                  props.setLpGroups([...newLpGroups]);
                }}></i>
              <Row className="pb-4 flex-column">
                <Col style={{ maxWidth: "60px" }}>Name:</Col>
                <Col>
                  <input
                    style={{ paddingLeft: "5px" }}
                    className="d-block"
                    value={jsDig(["name"], lpGroup) ? jsDig(["name"], lpGroup) : ""}
                    onChange={(e) => {
                      let newLpGroups = props.lpGroups;
                      let targetIndex = newLpGroups.indexOf(newLpGroups.find((group) => group.id == lpGroupId));
                      newLpGroups[targetIndex].name = e.target.value;
                      props.setLpGroups([...newLpGroups]);
                    }}
                  />
                </Col>
              </Row>
              {lpGroup.conditions &&
                lpGroup.conditions.map((condition, index) => {
                  return <React.Fragment key={index}>{conditionHtml(condition.type, condition.url, index, lpGroup.conditions.length)}</React.Fragment>;
                })}
              <div class= "landing-page-tracking-add-condition-button">
              <Row>
                <Col>
                  <Button
                    className="mt-3 px-4 btn-sm"
                    as="input"
                    type="button"
                    value="+ Add condition"
                    variant="success"
                    onClick={(e) => {
                      let newLpGroups = props.lpGroups;
                      let targetIndex = newLpGroups.indexOf(newLpGroups.find((group) => group.id == lpGroupId));
                      if (!newLpGroups[targetIndex].conditions) {
                        newLpGroups[targetIndex].conditions = [];
                      }
                      newLpGroups[targetIndex].conditions.push({ type: "equals", url: "" });
                      props.setLpGroups([...newLpGroups]);
                    }}
                  />
                </Col>
              
              </Row>
              </div>
            </div>
          </div>
        )}
      </Draggable>
    </>
  );
}
